import { closeManagedDialog, openManagedDialog } from "components/DialogV3/DialogManagerContext";

export const setOpenModal = ({ modal }) => () => {
    openManagedDialog({ element: modal, channel: 'legacy-modal' })
}

export const setCloseModal = () => () => {
    closeManagedDialog('legacy-modal')
}
